module.exports = __webpack_public_path__ + "static/media/toknu.5362f363.png";